<!-- eslint-disable max-len -->
<template>
  <div
    id="ticket-detail-view"
    class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 mt-md-0 mt-4 maxw-1750 pb-5"
  >
    <!-- HEADER -->
    <template  v-if="!loadingDetails && details != null">
      <!-- TITULO -->
      <div
        :class="[
          'section-mh d-flex flex-nowrap align-center justify-start',
          $vuetify.breakpoint.mdAndUp ? 'flex-row' : 'flex-column',
        ]"
        style="max-width: 100%"
      >
        <h2
          id="title"
          class="mx-4 mb-0 p-0 mt-4 mt-md-0 ml-0 disflex"
          :style="{ flex: $vuetify.breakpoint.mdOnly ? '100%' : '' }"
        >
          {{ details.referenceNumber }}-{{ details.summary }}
        </h2>
        <v-chip :color="stateColor(this.details.status.relAttr)" class="px-5 ml-1 mr-3 text-h6 col-auto">
          {{ this.tags[1].value }}
        </v-chip>
        <v-spacer
          class="middle-hr"
          :style="{ borderColor: $vuetify.theme.currentTheme.primary }"
        />

        <div
          v-if="$vuetify.breakpoint.mdAndUp"
          class="ticket-actions d-flex flex-row flex-nowrap justify-end col-auto px-0"
          :style="{ borderColor: $vuetify.theme.currentTheme.primary }"
        >
          <v-btn
            v-for="(action, i) in ticketActions"
            :key="i"
            icon
            class="ml-4"
            :class="[currentAction && action.name === currentAction.name ? 'btn-action' : '']"
            :id='"btn-ticket-action-" + action.name'
            @click.stop="viewAction(action)"
            @mouseover="actionHovered = action.name"
            @mouseleave="actionHovered = null"
          >
            <v-icon v-if="currentAction && action.name === currentAction.name">{{action.iconNegative}}</v-icon>
            <v-icon v-else>{{action.icon}}</v-icon>

            <!-- if action name has 11 or more characters we will adjust
              the last action name from the right to prevent the text out of screen -->
            <div
              :class="[
                'ticket-action-name',
                {
                  right: $t(`ticketActions.${action.name}.title`).length > 11,
                },
              ]"
            >
              <v-scroll-y-transition>
                <p v-if="actionHovered === action.name" class="text-body mb-0">
                  {{ $t(`ticketActions.${action.name}.title`) }}
                </p>
              </v-scroll-y-transition>
            </div>
          </v-btn>
        </div>
      </div>
      <!-- END TITULO -->
      <div v-if="findInteresado()" class="container__span__interesados">
        <i class="icon__interesado icon-ayudadigital-interesados-negativo" v-on="on"></i>
        <span>
          {{ $t("views.ticketDetail.subscriptions.interesado") }}
        </span>
      </div>
      <div v-if="findSeguidor()" class="container__span__interesados">
        <i class="icon__interesado icon-ayudadigital-ojo" v-on="on"></i>
        <span>
          {{ $t("views.ticketDetail.subscriptions.seguidor") }}

        </span>
      </div>

      <span v-if="isInfoCustomer === false">
        <template v-if="details.openDate">
          {{
            $t("views.ticketList.openDate", [
              $date("format", details.openDate),
            ])
          }}
        </template>

        <small class="mt-2" v-if="!isCitizen()">
          {{
            $tc(
              "views.ticketList.openedBy",
              getOpenedBy(details).length,
              getOpenedBy(details)
            )
          }}
        </small>
      </span>

      <a v-else class="btn__userCustomer" @click="toggleUserCustomer">
        <template v-if="details.openDate">
          {{
            $t("views.ticketList.openDate", [
              $date("format", details.openDate),
            ])
          }}
        </template>

        <small class="mt-2" v-if="!isCitizen()">
          {{
            $tc(
              "views.ticketList.openedBy",
              getOpenedBy(details).length,
              getOpenedBy(details)
            )
          }}
        </small>
        <v-icon :class="['icon__action', { 'rotate': girarUserCustomer }]">mdi-chevron-down</v-icon>
      </a>

      <template v-if="mostrarUserCustomer">
        <div class="container__userCustomer">
          <v-card class="card__container">
            <div class="card__element">
              <key-value-table
                :properties="dataUserCustomer(userCustomer)"
                class=""
              >
                <template #value="{ value }" v-if="$vuetify.breakpoint.mdAndUp">
                  <v-list-item-title class="text-right">
                    {{ value }}
                  </v-list-item-title>
                </template>
              </key-value-table>
            </div>
            <v-divider />
          </v-card>
        </div>
      </template>

      <v-spacer></v-spacer>
    </template>
    <!-- END HEADER -->

    <!-- ATTACH -->
    <template  v-if="!loadingDetails && details != null">
      <v-expand-transition>
        <v-col class="pa-0 ma-0 wrapper-attch" v-if="!!details.attachments.length">
          <v-card transition="scroll-x-transition">
            <v-chip-group show-arrows>
              <div class="wrapper__attch--file">
                <v-chip
                  v-for="(processedAttach, i) in processedAttachments"
                  :key="i"
                  class="ma-2 adjuntChip customPaddingFiles"
                  close
                  color="white"
                  text-color="primary"
                  close-icon="mdi-delete"
                  label
                  small
                  @click="download(processedAttach.attach.id, processedAttach.attach.name)"
                  @click:close="
                    (dialog = true),
                    (selectAttachName = processedAttach.attach.name),
                    (selectAttachId = processedAttach.attach.id)
                  "
                  :disabled="downloadProccess"
                >
                  <div class="d-flex flex-column pr-6">
                    <span class="icon-background">
                      <i
                        :class="['fa-solid', 'fa-2xl', 'pb-1', processedAttach.iconClass.icon.icon]"
                        :style="{ color: processedAttach.iconClass.icon.color }"
                      ></i>
                    </span>
                    <span>{{ processedAttach.attach.name }}</span>
                  </div>
                </v-chip>
              </div>
            </v-chip-group>
          </v-card>
          <v-dialog v-model="dialog" class="mx-auto" max-width="300">
            <v-card>
              <v-card-title>
                {{
                  $t("views.ticketDetail.attach.delete.dialog", [
                    selectAttachName,
                  ])
                }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog = false">
                  {{ $t("views.ticketDetail.attach.delete.reject") }}
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="deleteAttachment(selectAttachId)"
                >
                  {{ $t("views.ticketDetail.attach.delete.accept") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-expand-transition>
    </template>
    <!-- END ATTACH -->

    <!-- INIT DYNAMIC ACTION FORM -->
    <template>
      <v-card
        v-if="currentAction != null || currentActionVisible"
        class="mt-4 pa-4"
      >
        <v-expand-transition>
          <component
            v-if="currentAction != null && currentActionVisible"
            :is="currentAction.component"
            @refresh:detail="searchDetails()"
            @refresh:activities="searchActivities()"
            @update:detail="
              $emit('request', { type: 'updateTicketData', args: $event })
            "
            @input="currentAction = null"
            :ticket="details"
            :user="user"
            :formParams="action === currentAction.name ? params : ({})"
          ></component>
        </v-expand-transition>
      </v-card>
    </template>
    <!-- END DYNAMIC ACTION FORM -->

    <!-- ACTIVITIES -->
    <div class="mt-4" v-if="loadingActivities">
      <v-card v-for="i in 3" :key="`divider-${i}`" class="mx-0" tile>
        <v-skeleton-loader :key="i" type="list-item-three-line">
        </v-skeleton-loader>
      </v-card>
    </div>
    <template v-if="!loadingActivities && activities.length">
      <div>
        <div class="card__title">
          {{ $t("views.ticketDetail.activities.sectionTitle") }}
        </div>
        <v-card class="card__container">
          <div class="card__element" v-for="(activity, i) in activities" v-show="i < 2 || mostrarListaActi" :key="i">
            <v-list-item :key="i">
              <v-list-item-avatar class="mx-0 mx-md-initial">
                <v-icon left color="primary">{{ activity.icon }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ activity.type.webDescription }}
                </v-list-item-title>
                <v-list-item-subtitle
                  style="max-width: 100%; white-space: initial"
                >
                  <p
                    v-if="activity.analyst != null && !isCitizen()"
                    class="d-inline-block mt-1 mb-0 mr-4 text-truncate v-align-top"
                    style="max-width: inherit"
                  >
                    <v-icon small left>mdi-account</v-icon>
                    <span>{{ activity.analyst.name }}</span>
                  </p>
                  <p
                    class="d-inline-block mt-1 mb-0 text-no-wrap v-align-top"
                  >
                    <v-icon small left>mdi-calendar</v-icon>
                    <span>{{ activity.date | datetime }}</span>
                  </p>
                  <p
                    v-if="activity.zplanif_motivo_description != null
                    && activity.type.code === 'ACT_PLANI'"
                    class="mt-2 mb-0"
                    style="word-break: break-word"
                  >
                    {{ activity.zplanif_motivo_description }}
                  </p>
                  <p
                    v-if="activity.actionDescription != null"
                    class="d-block mt-2 mb-0 text-truncate"
                    style="max-width: inherit"
                  >
                    <!-- template for transfer from -> to -->
                    <template v-if="activity.type.code === 'ST' && activity.actionDescription.from !== activity.actionDescription.to">
                      <v-icon small left>mdi-state-machine</v-icon>
                      {{ activity.actionDescription.from }}
                      <v-icon small class="mx-1"
                        >mdi-arrow-right-thick</v-icon
                      >
                      {{ activity.actionDescription.to }}
                    </template>

                    <template v-else-if="activity.type.code === 'ST'">
                      {{ activity.actionDescription.from }}
                    </template>

                    <template v-else>
                      {{ activity.type.code }}
                    </template>
                  </p>
                  <p
                    v-if="activity.description != null"
                    class="mt-2 mb-0"
                    style="word-break: break-word"
                  >
                    <pre class='activity-description'><span>{{ activity.description }}</span></pre>
                  </p>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider :key="`divider-${i}`"/>
          </div>
          <button v-if="activities.length > 2" class="container__btnExpand" @click="toggleActi">
            <v-icon :class="['icon__action', { 'rotate': girarElementoActi }]">mdi-chevron-down</v-icon>
          </button>
        </v-card>
      </div>
    </template>
    <!-- END ACTIVITIES -->

    <!-- PLANIFICADA -->
    <div class="mt-4" v-if="loadingDetails">
      <v-card v-for="i in 10" :key="`divider-${i}`" class="mx-0" tile>
        <v-skeleton-loader :key="i" type="list-item-three-line">
        </v-skeleton-loader>
      </v-card>
    </div>
    <template v-if="activityPlanin">
      <div>
        <div class="card__title">
          {{ $t("views.ticketDetail.detailsSectionTitle.title") }}
        </div>
        <v-card class="card__container">
          <v-list class="py-md-0">
            <template >
              <v-list-item class="px-0 px-md-4">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ activityPlanin.type.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    style="max-width: 100%; white-space: initial"
                  >
                    <p
                      v-if="activityPlanin.analyst != null && !isCitizen()"
                      class="d-inline-block mt-1 mb-0 mr-4 text-truncate v-align-top"
                      style="max-width: inherit"
                    >
                      <v-icon small left>mdi-account</v-icon>
                      <span>{{ activityPlanin.analyst.name }}</span>
                    </p>
                    <p
                      v-if="details.call_back_date != null"
                      class="d-inline-block mt-1 mb-0 text-no-wrap v-align-top"
                    >
                      <v-icon small left>mdi-calendar</v-icon>
                      <span>
                        {{ $t("views.ticketDetail.requiredInformation.plannedDate") }}
                        <strong>
                          {{ details.call_back_date | datetime }}
                        </strong>
                      </span>
                    </p>
                    <p
                      v-if="activityPlanin.zplanif_motivo_description != null"
                      class="mt-2 mb-0"
                      style="word-break: break-word"
                    >
                      {{ activityPlanin.zplanif_motivo_description }}
                    </p>
                    <p
                      v-if="activityPlanin.description != null"
                      class="mt-2 mb-0"
                      style="word-break: break-word"
                    >
                      {{ activityPlanin.description }}
                    </p>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </div>
    </template>
    <!-- PLANIFICADA -->

    <!-- DETAILS -->
    <div class="mt-4" v-if="loadingDetails">
      <v-card v-for="i in 10" :key="`divider-${i}`" class="mx-0" tile>
        <v-skeleton-loader :key="i" type="list-item-three-line">
        </v-skeleton-loader>
      </v-card>
    </div>
    <template v-if="!loadingDetails && details != null">
      <div>
        <div class="card__title">
          {{ $t("views.ticketDetail.detailsSectionTitle") }}
        </div>
        <v-card class="card__container">
          <div class="card__element">
            <div v-if="details.description !== null" class="v-list elevation-2 wrapper__details">
              <p></p>
                <p>
                    <pre id="detailForm" class="mb-0 " style="white-space: pre-wrap;display: flex"><span :class="{'descriptionEllipsis': !this.showFullMessage && showMessageOrNot()}">{{ displayMessage() }}</span><span class="showMoreLink" v-if="!this.showFullMessage && showMessageOrNot()"
                        @click="toggleMessageVisibility()">...{{ $t('views.ticketDetail.detailsMore') }}</span>
                    </pre>
                </p>
              <p></p>
            </div>

            <v-divider />

            <key-value-table
              :properties="allDataDetails(mostrarListaDeta)"
              class=""
            >
              <template #value="{ value }" v-if="$vuetify.breakpoint.mdAndUp">
                <v-list-item-title class="text-right">
                  {{ value }}
                </v-list-item-title>
              </template>
            </key-value-table>
            <hr role="separator" aria-orientation="horizontal" class="v-divider theme--light">
            <div tabindex="-1" role="listitem" class="v-list-item theme--light">
              <div class="container__list--detailsPhone v-list-item__content justify-space-between flex-nowrap">
                <div class="v-list-item__title">
                  <v-icon class="-icon notranslate v-icon--left mdi mdi-phone theme--light"></v-icon>
                  <span class="title__details_phone">{{ $t("views.ticketDetail.additionalInfo.phoneTicket") }}</span>
                </div>

                <div v-if="!editPhoneTicket" class="text_list--detailsPhone v-list-item__title text-right">
                  <span>{{ obfuscatedPhone }} <i class="icon__detail--editPhone icon__detail--editPhonePencil icon-ayudadigital-edit" @click="modeEditPhone"></i></span>
                </div>

                <div v-if="editPhoneTicket" class="v-list-item__title text-right">
                  <div class="container__btn__editPhone">
                    <div>
                      <v-text-field
                        class="hide-details container__input--editPhone"
                        v-model="editingPhone"
                        @input="updatePhoneTicket"
                        placeholder="Introduce el nuevo teléfono"
                      ></v-text-field>
                      <div class="message__error--phone">
                        <span v-if="showMessageEditPhoneErrorEmpty">{{ $t('views.ticketDetail.additionalInfo.notValidEmpty') }}</span>
                        <span v-if="showMessageEditPhoneErrorFormat">{{ $t('views.ticketDetail.additionalInfo.notValidDigi') }}</span>
                      </div>
                    </div>
                    <div>
                      <v-btn icon @click="savePhoneTicket">
                        <i class="icon__detail--editPhone icon-ayudadigital-accept"></i>
                      </v-btn>
                      <v-btn icon @click="cancelEditPhone">
                        <i class="icon__detail--editPhone icon-ayudadigital-cancel"></i>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <v-divider />
          <button v-if="counteDeta > 2 || showExpandir" class="container__btnExpand" @click="toggleDeta">
            <v-icon :class="['icon__action', { 'rotate': girarElementoDeta }]">mdi-chevron-down</v-icon>
          </button>
        </v-card>
      </div>
    </template>
    <!-- END DETAILS -->

    <!-- WORKFLOW -->
    <div class="mt-4" v-if="loadingWorkFlow">
      <v-card v-for="i in 2" :key="`divider-workflow-${i}`" class="mx-0" tile>
        <v-skeleton-loader :key="i" type="list-item-one-line">
        </v-skeleton-loader>
      </v-card>
    </div>
    <template v-if="!loadingWorkFlow && workFlowFilters.length > 0">
      <h4 class="mt-4">{{ $t("views.ticketDetail.workFlow.sectionTitle") }}</h4>

      <v-spacer></v-spacer>

      <v-card class="mt-4">
        <v-sheet class="">
          <v-chip-group mandatory class="pa-2">
            <div class="wrapper__workflow">
              <template v-for="(work, i) in workFlowFilters">
                <v-chip :key="`chip-${i}`"
                  label :color="work.color"
                  class="chip-workflow"
                >
                  <v-icon left class="white--text">
                    {{ work.icon }}
                  </v-icon>
                  <span class="white--text">{{ work.contact }}</span>
                </v-chip>
                <v-icon class="icon__workflow" v-if="i < workFlow.length - 1" :key="`icon-${i}`">
                  mdi-arrow-right
                </v-icon>
              </template>
            </div>
          </v-chip-group>
        </v-sheet>
      </v-card>
    </template>
    <!-- END WORKFLOW -->

    <!-- RECLAMACIONES -->
    <template v-if="details && details.related != null && !!details.related.length">
      <div>
        <div class="card__title">
          {{ $t("views.ticketDetail.claimsTable.Title") }}
        </div>
        <v-card class="card__container">
          <div class="card__element">
            <v-data-table
              hide-default-footer
              :headers="tableHeaders"
              :items="formatRelated(mostrarListaRecla)"
              :items-per-page="15"
              :disable-sort="!$vuetify.breakpoint.mdAndUp"
            >
              <template v-slot:[`item.refNum`]="{ item }">
                <a @click="() => navigateTo(`${listURL}/${item.id}`)">{{ item.refNum }}</a>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                {{ item.date | datetime }}
              </template>
            </v-data-table>
          </div>
          <v-divider />
          <button v-if="countRecla > 3" class="container__btnExpand" @click="toggleRecla">
            <v-icon :class="['icon__action', { 'rotate': girarElementoRecla }]">mdi-chevron-down</v-icon>
          </button>
        </v-card>
      </div>
    </template>
    <!-- END RECLAMACIONES -->

    <!-- SUSCRIPCIONES -->
    <div class="mt-4" v-if="loadingSuscripciones">
      <v-card v-for="i in 10" :key="`divider-${i}`" class="mx-0" tile>
        <v-skeleton-loader :key="i" type="list-item-three-line">
        </v-skeleton-loader>
      </v-card>
    </div>
    <template v-if="!loadingSuscripciones && details != null">
      <div v-if="findInteresadoOnly()">
        <div class="card__title">
          {{ $t("views.ticketDetail.subscriptions.title") }}
        </div>
        <v-card class="card__container">
          <template>
            <v-chip
              v-for="(suscriptorItem, i) in allDataSuscripciones(mostrarListaSuscrip)"
              :key="i"
              class="ma-2"
              :model-value="true"
            >
              {{ suscriptorItem.name }}
              <button v-if="deletePermission(suscriptorItem)"
                @click.stop="deleteSuscripcion(suscriptorItem)"
              >
                <v-icon>mdi-delete</v-icon>
              </button>
            </v-chip>
          </template>
          <v-divider />
          <button class="container__btnExpand" @click="toggleSuscrip">
            <v-icon :class="['icon__action', { 'rotate': girarElementoSuscrip }]">mdi-chevron-down</v-icon>
          </button>
        </v-card>
      </div>
    </template>
    <!-- END SUSCRIPCIONES -->

    <!-- FLOATING ACTION BUTTONS -->
    <v-speed-dial
      v-if="!$vuetify.breakpoint.mdAndUp && !loadingDetails && details != null"
      v-model="fab"
      bottom
      right
      direction="top"
      transition="slide-y-reverse-transition"
      class="align-end"
      :style="{
          position: 'fixed',
          bottom: '70px',
          zIndex: '20',
        }"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="primary" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-menu</v-icon>
        </v-btn>
      </template>

      <div
        v-for="(action, i) in ticketActions"
        :key="i"
        class="d-flex flex-nowrap align-center"
      >
        <v-btn
          v-if="action.key !== 'ticketActions.export.title'"
          class="rounded-pill"
          color="primary--text grey lighten-4"
          dark
          @click.stop="openFabsButton(action)"
        >
          <span class="mr-2">{{ $t(action.key) }}</span>
          <v-icon small>{{ action.icon }}</v-icon>
        </v-btn>
      </div>
    </v-speed-dial>
    <!-- END FLOATING ACTION BUTTONS -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import mimeTypes from 'mime-types';
import { KeyValueTable } from '@/components';
import TicketActionsHandler from '@/components/ticket-actions';

const PLANNED_ACTIVITY = 'ACT_PLANI';
const PLANNED_ACTIVE = 1;
const SKIPPED_ACTIVITIES_FILTERS = ['CL', 'INIT', 'RE'];
const WORKFLOW_ICON_TYPES = {
  DEFAULT: 'mdi-check-circle-outline',
  REJ: 'mdi-close-circle',
  PEND_ORDER: 'mdi-eye',
  PEND: 'mdi-exclamation',
  END: 'mdi-wrench',
};

const WORKFLOW_COLOR_TYPES = {
  DEFAULT: 'green',
  REJ: 'red',
  PEND_ORDER: 'accent',
  PEND: 'primary',
};

export default {
  name: 'TicketDetailView',
  components: { KeyValueTable },
  props: {
    backButton: Boolean,
    ticketType: {
      type: String,
      required: true,
    },
    idTicket: {
      type: String || Number,
      required: true,
    },
    details: {
      type: Object,
    },
    activities: {
      type: Array,
      default: () => [],
    },
    suscriptores: {
      type: Array,
      default: () => [],
    },
    action: String,
    params: {
      type: Object,
      default: () => ({}),
    },
    workFlow: {
      type: Array,
      default: () => [],
    },
    loadingDetails: Boolean,
    loadingActivities: Boolean,
    loadingWorkFlow: Boolean,
    loadingSuscripciones: Boolean,
    backURL: String,
    listURL: {
      type: String,
      default: () => '/requests',
    },
  },
  data: ({ action }) => ({
    panel: 0,
    readonly: false,
    activitiesFilter: null,
    fab: false,
    initialAction: action || null,
    currentAction: null,
    currentActionVisible: false,
    actionHovered: null,
    expandAttachs: false,
    dialog: false,
    selectAttachName: null,
    selectAttachId: null,
    downloadProccess: false,
    zmot_parada: null,
    call_back_date: null,
    isInitFlow: false,
    activityPlanin: null,
    expandedClaim: false,
    message: [],
    messageAux: [],
    isExpandedActi: false,
    isExpandedDeta: false,
    isExpandedRecla: false,
    isExpandedSuscrip: false,
    mostrarListaActi: false,
    girarElementoActi: false,
    mostrarListaDeta: false,
    girarElementoDeta: false,
    mostrarListaRecla: false,
    girarElementoRecla: false,
    mostrarListaPlani: false,
    girarElementoPlani: false,
    mostrarUserCustomer: false,
    girarUserCustomer: false,
    mostrarListaSuscrip: true,
    girarElementoSuscrip: true,
    showExpandir: false,
    counteDeta: 0,
    countRecla: 0,
    mimeTypeIcons: {},
    userCustomer: {},
    isSearchCustomer: false,
    isInfoCustomer: false,
    isInteresado: false,
    editPhoneTicket: false,
    phoneTicket: null,
    editingPhone: '',
    showFullMessage: false,
    suscriptorOnly: [],
    showMessageEditPhoneErrorEmpty: false,
    showMessageEditPhoneErrorFormat: false,
    codigoInteresado: 400001,
    codigoSeguidor: 400002,
  }),
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    tags() {
      return [
        {
          icon: 'mdi-tag-outline',
          value: this.details.affectedResource.name,
        },
        {
          icon: 'mdi-checkbox-multiple-blank-outline',
          value: this.details.status.zdescripcion_web
            ? this.details.status.zdescripcion_web
            : this.details.status.name,
        },
        {
          icon: 'mdi-check-box-outline',
          value: this.details.category.name,
        },
      ];
    },
    colors() {
      return this.$getConst('dashboard.filtersColors');
    },
    stateColor() {
      return (state) => {
        let newState = state;
        if (state === 'RCHZ') {
          newState = 'DRCHZ';
        }
        return this.colors[newState] || '#a40e0e';
      };
    },
    activitiesFilters() {
      return this.activities
        .filter(({ type }) => !SKIPPED_ACTIVITIES_FILTERS.includes(type.code))
        .map(({ icon }) => icon)
        .filter((icon, i, list) => icon !== 'mdi-asterisk' && list.indexOf(icon) === i);
    },
    filteredActivities() {
      if (this.activities == null) {
        return this.activities;
      }
      return this.activities.filter(
        ({ icon }) => icon === this.activitiesFilter,
      );
    },
    tableHeaders() {
      return [
        { text: 'code', value: 'refNum' },
        { text: 'type', value: 'type' },
        { text: 'date', value: 'date' },
        { text: 'state', value: 'state' },
      ].map((tableHeader) => ({
        ...tableHeader,
        text: this.$t(`views.ticketDetail.claimsTable.${tableHeader.text}`),
      }));
    },
    ticketActions() {
      const ticketSeguidor = {
        isPulso: false,
      };

      const actions = TicketActionsHandler
        .performTicketActions(this.details, this.user, this.suscriptores, ticketSeguidor);

      if (this.details.category.id === this.$getConst('clone.category')) {
        return actions.filter((action) => action.name !== this.$getConst('clone.name'));
      }
      return actions;
    },
    workFlowFilters() {
      const workResult = [];
      const listWorkFlow = this.workFlow;
      listWorkFlow.forEach((work, i) => {
        const { contact } = work;
        workResult.push({
          contact: contact !== null ? work.contact.fullName : '',
          icon: this.iconWorkFlow(work.order, work.status, i === (listWorkFlow.length - 1)),
          color: this.colorWorkFlow(work.order, work.status),
        });
      });
      return workResult;
    },
    isMobile() {
      const getter = this.$store.getters['globalState/get'];
      return getter('deviceOS') != null;
    },
    openPanel() {
      return 0;
    },
    processedAttachments() {
      return this.details.attachments.map((attach) => {
        const mimeType = this.getMimeTypeByFileName(attach.name);
        const iconClass = this.getFontAwesomeIconFromMIME(mimeType);

        return {
          attach,
          mimeType,
          iconClass,
        };
      });
    },
    obfuscatedPhone() {
      const phone = this.details?.phoneTicket || '';
      if (!phone || phone === '') {
        return '';
      }

      const visibleChars = 3;
      const endIndex = phone.length - visibleChars;
      const asterisks = '*'.repeat(Math.max(0, endIndex));
      return `${asterisks}${phone.substring(endIndex)}`;
    },
  },
  methods: {
    modeEditPhone() {
      this.editPhoneTicket = true;
      this.editingPhone = '';
      this.showMessageEditPhoneErrorEmpty = false;
      this.showMessageEditPhoneErrorFormat = false;
    },
    async savePhoneTicket() {
      this.showMessageEditPhoneErrorEmpty = false;
      this.showMessageEditPhoneErrorFormat = false;
      const isValid = this.mobileValidation(this.editingPhone);

      if (isValid === null) {
        this.showMessageEditPhoneErrorEmpty = true;
        this.showMessageEditPhoneErrorFormat = false;
      } else if (!isValid) {
        this.showMessageEditPhoneErrorEmpty = false;
        this.showMessageEditPhoneErrorFormat = true;
      } else {
        const messageId = await this.$store.dispatch('messages/createNotificationMessage', {
          icon: 'progress-circular',
          title: this.$t('views.ticketDetail.additionalInfo.phoneTicketModify'),
        });
        try {
          await this.ticketClient.savePhoneTicket({
            idTicket: this.details.id,
            phoneTicket: this.editingPhone,
            timeout: this.$getConst('notifications.timeout'),
            dismissible: true,
          });
          this.details.phoneTicket = this.editingPhone;
          this.editPhoneTicket = false;
          this.editingPhone = '';
          this.showMessageEditPhoneErrorEmpty = false;
          this.showMessageEditPhoneErrorFormat = false;
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'success',
            icon: 'mdi-check-circle',
            title: this.$t('views.ticketDetail.additionalInfo.phoneTicketSuccess'),
            timeout: this.$getConst('notifications.timeout'),
          });
        } catch (ex) {
          this.editPhoneTicket = false;
          this.editingPhone = '';
          this.showMessageEditPhoneErrorEmpty = false;
          this.showMessageEditPhoneErrorFormat = false;
          console.error('error delete  attach', ex);
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'error',
            icon: 'mdi-times',
            dismissible: true,
            title: this.$t('views.ticketDetail.additionalInfo.phoneTicketError'),
            timeout: this.$getConst('notifications.timeout'),
          });
        }
      }
    },
    updatePhoneTicket(newPhoneEdit) {
      this.editingPhone = newPhoneEdit;
      const isValid = this.mobileValidation(newPhoneEdit);
      if (isValid === null) {
        this.showMessageEditPhoneErrorEmpty = true;
        this.showMessageEditPhoneErrorFormat = false;
      } else if (!isValid) {
        this.showMessageEditPhoneErrorEmpty = false;
        this.showMessageEditPhoneErrorFormat = true;
      } else {
        this.showMessageEditPhoneErrorEmpty = false;
        this.showMessageEditPhoneErrorFormat = false;
      }
    },
    cancelEditPhone() {
      this.editingPhone = '';
      this.editPhoneTicket = false;
      this.showMessageEditPhoneErrorEmpty = false;
      this.showMessageEditPhoneErrorFormat = false;
    },
    mobileValidation(value) {
      if (value == null || value === '') {
        return null;
      }

      return (
        value == null
        || value === ''
        || /^[0-9]{6}$|^[0-9]{9}$/.test(value)
      ) || false;
    },
    deletePermission(suscriptorItem) {
      if (this.details?.customer?.id === this.user.id) {
        return true;
      }
      if (suscriptorItem.uuid === this.user.id) {
        return true;
      }
      return false;
    },
    toggleActi() {
      this.mostrarListaActi = !this.mostrarListaActi;
      this.girarElementoActi = !this.girarElementoActi;
    },
    toggleDeta() {
      if (this.showFullMessage === false
      || (this.mostrarListaDeta === false && this.showFullMessage === false)) {
        this.toggleMessageVisibility();
      }
      this.mostrarListaDeta = !this.mostrarListaDeta;
      this.girarElementoDeta = !this.girarElementoDeta;
    },
    toggleRecla() {
      if (!this.mostrarListaRecla) {
        this.toggleAllClaims();
      }
      this.mostrarListaRecla = !this.mostrarListaRecla;
      this.girarElementoRecla = !this.girarElementoRecla;
    },
    togglePlani() {
      this.mostrarListaPlani = !this.mostrarListaPlani;
      this.girarElementoPlani = !this.girarElementoPlani;
    },
    toggleUserCustomer() {
      this.mostrarUserCustomer = !this.mostrarUserCustomer;
      this.girarUserCustomer = !this.girarUserCustomer;
    },
    toggleSuscrip() {
      this.mostrarListaSuscrip = !this.mostrarListaSuscrip;
      this.girarElementoSuscrip = !this.girarElementoSuscrip;
    },

    searchDetails() {
      const { ticketType, idTicket, user } = this;
      this.$emit('request', {
        type: 'detail',
        args: {
          ticketType,
          idTicket,
          user: user.id,
        },
      });
    },

    navigateTo(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push({ path });
        this.$router.go(0);
      }
    },

    formatRelated(type) {
      let arrDetails = [];
      if (type) {
        arrDetails = this.details.related.map((item) => ({
          refNum: item.referenceNumber,
          id: item.id,
          type: item.claimType ? item.claimType.name : '-',
          date: item.openDate,
          state: item.status.webDescription,
        }));
      } else {
        const claimArray = this.details.related.map((item) => ({
          refNum: item.referenceNumber,
          id: item.id,
          type: item.claimType ? item.claimType.name : '-',
          date: item.openDate,
          state: item.status.webDescription,
        }));
        arrDetails = claimArray.slice(0, 3);
      }
      this.countRecla = this.details.related.length;
      return arrDetails;
    },

    formatRelatedLast() {
      const claimArray = this.details.related.map((item) => ({
        refNum: item.referenceNumber,
        id: item.id,
        type: item.claimType ? item.claimType.name : '-',
        date: item.openDate,
        state: item.status.webDescription,
      }));

      const lastClaim = [claimArray[claimArray.length - 1]];
      return lastClaim;
    },

    getOpenedBy(detail) {
      const openedBy = ['requestedBy', 'customer'].map(
        (key) => (detail[key] || {}).name,
      );
      return openedBy.filter((key, i, arr) => arr.indexOf(key) === i);
    },

    viewAction(action) {
      if (this.currentAction == null || this.currentAction.name !== action.name) {
        this.currentAction = action;
      } else {
        this.currentAction = null;
      }
    },

    async deleteAttachment(attachId) {
      this.dialog = false;
      this.downloadProccess = true;
      const messageId = await this.$store.dispatch('messages/createNotificationMessage', {
        icon: 'progress-circular',
        title: this.$t('views.ticketDetail.attach.delete.process'),
      });
      try {
        await this.$api.getClient('ticket').delete(this.details.id, attachId, this.details.referenceNumber);
        this.searchDetails();
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'success',
          icon: 'mdi-check-circle',
          title: this.$t('views.ticketDetail.attach.success'),
          timeout: this.$getConst('notifications.timeout'),
        });
      } catch (ex) {
        console.error('error delete  attach', ex);
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$t('views.ticketDetail.attach.error'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
      this.downloadProccess = false;
    },

    async download(attachId, nameFile) {
      if (!this.isMobile) {
        this.downloadProccess = true;
      }
      await this.$api.getClient('ticket').download(this.details.id, attachId, this.details.referenceNumber, nameFile);
      if (!this.isMobile) {
        this.downloadProccess = false;
      }
    },

    iconWorkFlow(orderTicket, status, position) {
      let icon = WORKFLOW_ICON_TYPES.DEFAULT;
      if (position) {
        icon = WORKFLOW_ICON_TYPES.END;
      } else if (status === 'PEND') {
        icon = (this.details || {}).approbalWorkflowOrder === String(orderTicket)
          ? WORKFLOW_ICON_TYPES.PEND_ORDER : WORKFLOW_ICON_TYPES.PEND;
      } else if (status === 'REJ') {
        icon = WORKFLOW_ICON_TYPES.REJ;
      }
      return icon;
    },

    colorWorkFlow(orderTicket, status) {
      let color = WORKFLOW_COLOR_TYPES.DEFAULT;
      if (status === 'PEND') {
        color = (this.details || {}).approbalWorkflowOrder === String(orderTicket)
          ? WORKFLOW_COLOR_TYPES.PEND_ORDER : WORKFLOW_COLOR_TYPES.PEND;
      } else if (status === 'REJ') {
        color = WORKFLOW_COLOR_TYPES.REJ;
      }
      return color;
    },

    isCitizen() {
      return this.user.hasIosUser();
    },

    openFabsButton(action) {
      this.currentAction = action;
      this.fab = !this.fab;
    },

    parseResolution(resolution) {
      return resolution
        .replace(/\n/g, '<br />');
    },
    updateInitFlow() {
      this.isInitFlow = true;
    },
    getPlannedActivity() {
      const activities = [];
      const {
        zmot_parada: zmotParada,
        call_back_date: callBackDate,
      } = this.details;

      if (
        this.activities.length === 0
        || zmotParada == null
        || callBackDate == null
      ) return activities;

      const btnAction = document.getElementById('btn-ticket-action-comment');
      const listActivities = this.activities
        .filter(({ zplanif_motivo: planifMotivo, type, zcheck }) => (
          planifMotivo === zmotParada
          && zcheck === PLANNED_ACTIVE
          && type.code === PLANNED_ACTIVITY
        ));

      if (
        listActivities.length > 0
        && !this.isInitFlow
        && btnAction
      ) {
        listActivities.sort((a, b) => b.date - a.date);
        this.activityPlanin = { ...listActivities[0] };
        btnAction.click();
      }
      this.updateInitFlow();
      return listActivities[0];
    },
    allDataDetails(type) {
      let arrData = [];
      const basicData = this.basicDetails();
      const additionalData = this.additionalDetails();
      const allData = [...basicData, ...additionalData];

      this.counteDeta = allData.length || 0;

      if (type) {
        arrData = allData;
      } else {
        arrData = allData.slice(0, 2);
      }

      return arrData;
    },
    dataUserCustomer(data) {
      return this.formatDataUserCustomer(data);
    },
    formatDataUserCustomer(data) {
      const arrData = [];
      if (data) {
        const dataOrganizacionFuncional = {
          icon: 'mdi-cog',
          key: 'Organización Funcional',
          value: data.organizacionFuncional,
        };
        arrData.push(dataOrganizacionFuncional);

        const dataUbicacionFisica = {
          icon: 'mdi-cog',
          key: 'Centro',
          value: data.ubicacionFisica.edificio.nombre,
        };
        arrData.push(dataUbicacionFisica);

        const dataCargo = {
          icon: 'mdi-cog',
          key: 'Categoría Profesional',
          value: data.cargo.nombre,
        };
        arrData.push(dataCargo);

        const dataTelefono = {
          icon: 'mdi-cog',
          key: 'Teléfono',
          value: data.telefonoPreferente,
        };
        arrData.push(dataTelefono);

        const dataEmail = {
          icon: 'mdi-cog',
          key: 'Email',
          value: data.email,
        };
        arrData.push(dataEmail);
      }
      return arrData;
    },
    allDataSuscripciones(type) {
      let arrData = [];
      const allData = this.suscriptores
        .filter((item) => item.codigoFlujo === this.codigoInteresado);

      if (type) {
        arrData = allData;
      }

      return arrData;
    },
    async deleteSuscripcion(userDelete) {
      const messageId = await this.$store.dispatch('messages/createNotificationMessage', {
        icon: 'progress-circular',
        title: this.$t('views.ticketDetail.subscriptions.process'),
      });
      try {
        const { userid } = this.$store.getters['session/user'];

        const response = await this.suscriptorsClient.deleteSuscriptors({
          apiCges: {
            delegado: userid,
            endpoint: `cges/solicitudes/${ this.details.referenceNumber }/suscriptores/${ userDelete.uuid }`,
          },
          id: this.details.referenceNumber,
          uuid: userDelete.uuid,
        });

        if (response.status === 200) {
          const newArray = this.suscriptores.filter((item) => item.uuid !== userDelete.uuid);
          this.suscriptores = newArray;
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'success',
            icon: 'mdi-check-circle',
            title: this.$t('views.ticketDetail.subscriptions.success'),
            timeout: this.$getConst('notifications.timeout'),
          });
        } else {
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'error',
            icon: 'mdi-close-circle',
            title: this.$t('views.ticketDetail.subscriptions.error'),
            timeout: this.$getConst('notifications.timeout'),
          });
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$t('views.ticketDetail.subscriptions.error'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    basicDetails() {
      return this.details.properties
        .filter((item) => item.name !== 'initialAssignee')
        .map(({ name, value }) => ({
          icon: 'mdi-cog',
          key: name,
          value,
        }));
    },
    additionalDetails() {
      const data = [
        {
          key: 'views.ticketDetail.additionalInfo.location',
          icon: 'mdi-earth',
          value: this.details.location.name,
        },
        {
          key: 'views.ticketDetail.additionalInfo.environment',
          icon: 'mdi-server',
          value: this.details.entorno,
        },
      ];

      if (this.details.parent && this.details.claimType) {
        data.push(
          {
            key: (this.details.category || {}).id === this.$getConst('claim.category')
              ? 'views.ticketDetail.additionalInfo.isClaimFromParent' : 'views.ticketDetail.additionalInfo.isClaimFromOrigin',
            icon: 'mdi-arrow-left-right',
            value: this.details.parent.referenceNumber,
            claim: true,
          },
          {
            key: 'views.ticketDetail.additionalInfo.claimType',
            icon: 'mdi-exclamation-thick',
            value: this.details.claimType.name,
          },
        );
      }
      if (this.details.zreclamaciones) {
        data.push({
          key: 'views.ticketDetail.additionalInfo.totalClaims',
          icon: 'mdi-exclamation-thick',
          value: this.details.zreclamaciones,
        });
      }

      if (this.details.phoneTicket) {
        this.phoneTicket = this.phoneTicket === null ? this.details.phoneTicket : this.phoneTicket;
      }

      data.map((additionalDetail) => ({
        ...additionalDetail,
        key: this.$t(additionalDetail.key),
      }));

      this.getPlannedActivity();

      return data;
    },
    initToggleMessageVisibility() {
      this.showFullMessage = false;
      this.mostrarListaDeta = false;
      this.girarElementoDeta = false;
    },
    toggleMessageVisibility() {
      this.showFullMessage = !this.showFullMessage;
    },
    toggleAllClaims() {
      this.showAllClaims = !this.showAllClaims;
      this.formatRelated(this.mostrarListaRecla);
    },
    displayMessage() {
      const messageAux = this.details.description || '';
      const characterMax = messageAux ? this.descriptionShowCharacter(messageAux.length) : this.$getConst('ticketDetailView.character');
      if (this.showFullMessage) {
        return messageAux;
      }
      this.showExpandir = messageAux.length > characterMax;
      return messageAux.length > characterMax
        ? `${messageAux.slice(0, characterMax)}`
        : messageAux;
    },
    descriptionShowCharacter(messageAux) {
      let characterCalc = 50;
      if (window.screen.width >= 1024) {
        characterCalc = messageAux;
      }
      return characterCalc;
    },
    showMessageOrNot() {
      const characterMax = this.$getConst('ticketDetailView.character');
      const messageAux = this.details.description || '';
      if (window.screen.width < 1024) {
        return messageAux.length > characterMax;
      }
      if (window.screen.width >= 1024 && window.screen.width < 1440) {
        return messageAux.length > 100;
      } if (window.screen.width >= 1440 && window.screen.width < 1980) {
        return messageAux.length > 140;
      }
      return messageAux.length > 200;
    },
    getMimeTypeByFileName(fileName) {
      return mimeTypes.lookup(fileName);
    },
    getFontAwesomeIconFromMIME(mimeType) {
      const iconClasses = {
        'image/png': {
          icon: 'fa-file-image',
          color: '#27846D',
        },
        'image/bmp': {
          icon: 'fa-file-image',
          color: '#27846D',
        },
        'image/jpeg': {
          icon: 'fa-file-image',
          color: '#27846D',
        },
        'image/x-png': {
          icon: 'fa-file-image',
          color: '#27846D',
        },
        'image/gif': {
          icon: 'fa-file-image',
          color: '#27846D',
        },
        'audio/mpeg': {
          icon: 'fa-file-audio',
          color: '#27846D',
        },
        'audio/x-ms-wma': {
          icon: 'fa-file-audio',
          color: '#27846D',
        },
        'audio/mp4': {
          icon: 'fa-file-audio',
          color: '#27846D',
        },
        'video/x-msvideo': {
          icon: 'fa-file-video',
          color: '#27846D',
        },
        'video/mpeg': {
          icon: 'fa-file-video',
          color: '#27846D',
        },
        'video/mp4': {
          icon: 'fa-file-video',
          color: '#27846D',
        },
        'application/pdf': {
          icon: 'fa-file-pdf',
          color: '#ff0000',
        },
        'application/msword': {
          icon: 'fa-file-word',
          color: '#1B5EBE',
        },
        'application/vnd.ms-word': {
          icon: 'fa-file-word',
          color: '#1B5EBE',
        },
        'application/vnd.oasis.opendocument.text': {
          icon: 'fa-file-word',
          color: '#1B5EBE',
        },
        'application/vnd.openxmlformats-officedocument.wordprocessingml': {
          icon: 'fa-file-word',
          color: '#1B5EBE',
        },
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
          icon: 'fa-file-word',
          color: '#1B5EBE',
        },
        'application/vnd.ms-excel': {
          icon: 'fa-file-excel',
          color: '#10793F',
        },
        'application/vnd.openxmlformats-officedocument.spreadsheetml': {
          icon: 'fa-file-excel',
          color: '#10793F',
        },
        'application/vnd.oasis.opendocument.spreadsheet': {
          icon: 'fa-file-excel',
          color: '#10793F',
        },
        'application/vnd.ms-excel.sheet.binary.macroenabled.12': {
          icon: 'fa-file-excel',
          color: '#10793F',
        },
        'application/vnd.ms-powerpoint': {
          icon: 'fa-file-powerpoint',
          color: '#C13B1B',
        },
        'application/vnd.openxmlformats-officedocument.presentationml': {
          icon: 'fa-file-powerpoint',
          color: '#C13B1B',
        },
        'application/vnd.oasis.opendocument.presentation': {
          icon: 'fa-file-powerpoint',
          color: '#C13B1B',
        },
        'text/plain': {
          icon: 'fa-file-text',
          color: '#27846D',
        },
        'text/html': {
          icon: 'fa-file-code',
          color: '#27846D',
        },
        'application/json': {
          icon: 'fa-file-code',
          color: '#27846D',
        },
        'application/gzip': {
          icon: 'fa-file-archive',
          color: '#27846D',
        },
        'application/zip': {
          icon: 'fa-file-archive',
          color: '#27846D',
        },
      };

      const iconClass = {
        icon: {
          icon: 'fa-file',
          color: '#27846D',
        },
      };

      Object.keys(iconClasses).forEach((key) => {
        if (mimeType === key) {
          iconClass.icon = iconClasses[key];
        }
      });

      return iconClass;
    },
    findInteresado() {
      const { id } = this.$store.getters['session/user'];
      const interesadosOnly = this.suscriptores
        .filter((item) => item.codigoFlujo === this.codigoInteresado);
      return interesadosOnly.some((suscriptor) => suscriptor.uuid === id);
    },
    findSeguidor() {
      const { id } = this.$store.getters['session/user'];
      const segudorOnly = this.suscriptores
        .filter((item) => item.codigoFlujo === this.codigoSeguidor);
      return segudorOnly.some((suscriptor) => suscriptor.uuid === id);
    },
    findInteresadoOnly() {
      const suscriptorOnly = this.suscriptores
        .filter((item) => item.codigoFlujo === this.codigoInteresado);
      return suscriptorOnly.length > 0;
    },

  },
  created() {
    this.userClient = this.$api.getClient('user');
    this.suscriptorsClient = this.$api.getClient('suscriptors');
    this.ticketClient = this.$api.getClient('ticket');
    this.searchDetails();
  },
  async updated() {
    const PEND_APRO = this.$getConst('ticketType.pendApro');
    if (this.details != null && this.initialAction != null) {
      const action = this.ticketActions.find(({ name }) => name === this.initialAction);
      this.initialAction = null;
      if (action != null) {
        this.$nextTick(() => {
          this.viewAction(action);
        });
      }
      (this.details.attachments || []).forEach((attach) => {
        const mimeType = this.getMimeTypeByFileName(attach.name);
        const icon = this.getFontAwesomeIconFromMIME(mimeType);
        this.$set(this.mimeTypeIcons, attach.name, icon);
      });
    }

    let status = {};
    if (this.details !== null && this.details !== undefined) {
      status = this.details.status;
    }

    if (
      this.isSearchCustomer === false
      && status
      && status.relAttr === PEND_APRO
      && Object.keys(this.userCustomer).length === 0
      && this.details
      && this.details.customer
    ) {
      const uuidContact = this.details.customer.id;
      try {
        const { id, userid } = await this.$store.getters['session/user'];
        const response = await this.userClient.getUserCustomer({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `cges/links/contactos/${ uuidContact }`,
          },
        });
        if (response === '') {
          this.isInfoCustomer = false;
        } else {
          this.isInfoCustomer = true;
        }

        this.userCustomer = response?.collection_userCustomer?.userCustomer;
        this.isSearchCustomer = true;
      } catch (error) {
        this.isSearchCustomer = true;
        console.log(error);
      }
    }
  },
  watch: {
    currentAction(newval, oldval) {
      console.log('current action changed from', oldval, 'to', newval);
      if (newval == null) {
        // wait for transition end to hide the card container
        setTimeout(() => {
          this.currentActionVisible = false;
        }, 200);
      } else {
        this.$nextTick(() => {
          this.currentActionVisible = true;
        });
      }
      return newval;
    },
  },
};
</script>
<style lang="scss">
$section-min-height: 24px;

#ticket-detail-view {
  .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: initial;
  }

  .icon-ayudadigital-exportar::before  {
    color:grey !important;
    font-weight: bold !important;
  }

  .icon-ayudadigital-escalar::before  {
    color:grey !important;
    font-weight: bold !important;
  }

  .icon-ayudadigital-accion-interesados::before  {
    color: rgba(0, 0, 0, 0.54);
    font-size: 32px;
  }

  .section-mh {
    min-height: $section-min-height;
  }

  .mw-100 {
    max-width: 100%;
  }

  .v-align-top {
    vertical-align: top;
  }

  .v-expansion-panel-content__wrap {
    padding: 0 8px;

    @media (min-width: 960px) {
      padding: initial;
    }
  }

  .v-speed-dial__list {
    align-items: flex-end;
  }
}

.v-application--is-ltr .v-expansion-panel-header__icon {
  margin: 0 auto;
}
.showMoreLink {
    color: #27846d;
    cursor: pointer;
    font-size: 14px;
    margin-left: 0.25rem;
    display: flex;
    align-items: end;
    /*text-decoration: underline;*/
}
.descriptionEllipsis{
    max-width: 95%;
    white-space: nowrap !important;
    overflow: hidden !important;
    margin-right: 0.25rem;
}
</style>

<style lang="scss" scoped>
$ticket-action-button-size: 55px;
$ticket-action-bottom: -45px;
$ticket-action-last-item-right: -40px;
$ticket-action-last-item-right-mdandup: -50px;

.v-slide-group__next--disabled, .v-slide-group__prev--disabled {
  display: none;
}

.v-slide-group__next, .v-slide-group__prev {
  min-width: 42px !important;
}
#title {
  word-break: break-word;

  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  hyphens: auto;
}
.middle-hr {
  border-color: inherit;
  border-width: 1px 0;
  border-style: solid;
}

.ticket-actions {
  position: relative;

  > button {
    width: $ticket-action-button-size;
    height: $ticket-action-button-size;
    border-radius: 50%;
    border-color: inherit;
    border-width: 2px;
    border-style: solid;
    background-color: white;

    &:last-child .ticket-action-name.right {
      left: 100%;
      display: table;
      transform: translateX(-100%);
    }
  }
  .ticket-action-name {
    pointer-events: none;
    position: absolute;
    bottom: $ticket-action-bottom;
    left: 50%;
    transform: translateX(-50%);
  }
}
.primary--border {
  border-width: 1px;
  border-style: solid;
}
.chip-workflow {
  pointer-events: none;
}
.wrapper__details {
  background-color: #ffffff;
  display: block;
  padding: 12px;
}
.wrapper-attch {
  margin-top: 0.5rem !important;
}
.mt-0 {
  margin-top: 0;
}
.separator__table {
  border-color: #dedede;
}
.btn__more {
  background-color: transparent !important;
  cursor: pointer;
  border: none;
  color: #27846d;
  padding: 0 !important;
  height: initial !important;
  box-shadow: none;
}
.wrapper-btn {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
.wrapper__workflow {
  display: flex;
  flex-wrap: wrap;
}
.kaiPlus > .v-slide-group__wrapper > .v-slide-group__content {
  background-color: red;
  justify-content: end!important;
}
.wrapper__attch--file {
  display: flex;
  width: 100%;
  justify-content: end;
}
.pb-5 {
  padding-bottom: 5rem!important;
}
.header__expansion--title {
  color: #27846d !important;
  font-size: 0.875rem;
}

.fade-in {
  opacity: 1;
  transition: opacity 0.5s ease-in;
}

.fade-out {
  opacity: 0;
  transition: opacity 0.5s ease-out;
}

button i {
  transition: transform 0.3s ease-in-out;
}

button.rotate i.fa-chevron-up {
  transform: rotate(180deg);
}
.card__title {
  font-weight: bold;
  margin: 1rem 0;
}

.rotate {
  transform: rotate(180deg);
}
.icon__action {
  color: #27846d;
}
.container__btnExpand {
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  width: 100%;
}

.icon-background {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 13.5px;
}

.adjuntChip {
  border: 2px solid #f1f1f1 !important;
}

.container__userCustomer {
  margin-top: 1rem;
}

.card__element_suscriptores div {
  padding: 0;
}

.btn-action i{
    font-size: 5.4rem !important;
    //margin-top: 1px;
    //margin-right: 3px;
}

.disflex {
  display: flex;
  align-items: center;
}

.icon__interesado {
  font-size: 2rem;
}

.container__span__interesados {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.ml-0 {
  margin-left: 0.5rem;
}

.container__btn__editPhone {
  display: flex;
  align-items: center;
  justify-content: right;
}

.container__input--editPhone {
  width: 270px;
}

.icon__detail--editPhone {
  display: inline-flex;
  font-size: 24px;
  line-height: 1;
  vertical-align: middle;
  cursor: pointer;
}
.icon__detail--editPhone::before {
  color: #0000008a !important;
}
.icon__detail--editPhonePencil {
  font-size: 30px;
}

@media (max-width: 600px) {
  .icon__workflow {
    transform: rotate(90deg);
    margin-top: 0.5rem;
  }

  #title {
    margin-top: 0px !important;
    font-size: 16px !important;
    align-self: flex-start;
  }
}

@media (max-width: 960px) {
  #ticket-detail-view {
    .icon-ayudadigital-escalar::before  {
      color:#27846d !important;
    }
    .icon-ayudadigital-accion-interesados::before  {
      color:#27846d !important;
      font-size: inherit;
    }
  }
  .container__list--detailsPhone {
    flex-direction: column;
  }
  .text_list--detailsPhone {
    text-align: left !important;
    margin-top: 10px;
  }
  .v-list-item__title {
    width: 100%;
  }
  .container__input--editPhone {
    width: 250px;
  }
  .message__error--phone {
    padding: 0!important;
  }
}

.activity-description {
  font-family: 'Source Sans Pro', sans-serif;
  text-wrap: wrap;
}
.message__error--phone{
  line-height: 12px;
  color: #b64351;
  caret-color: #b64351;
  text-align: left;
  font-size: 10.4px;
  padding: 0 12px;
  margin-top: -10px;
}
.title__details_phone {
  margin-left: 3px;
}

.customPaddingFiles {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}
</style>
